jQuery(document).ready(function($) {
    const header = document.querySelector('.header');
    let scrollY = 0;


    window.addEventListener('scroll', function() {
        if (window.scrollY > 0) {
            header.classList.add('bg-blue500');
        } else {
            header.classList.remove('bg-blue500');
        }

    });
});
